import { capitalize, onlyNumbers } from "@/utils/genericals";
import { authApi } from "../api";
import { MessageSenderTypeEnum } from "@/utils/enums/MessageSenderTypeEnum";
import { User } from "@/@types/app/user";
import { Token } from "../apiServiceBuilder";

type UserForm = {
	state: string;
	city: string;
	occupation: string;
	name: string;
	identifier: string;
	email: string;
	phone: string;
	password: string;
	confirmPassword: string;
};

type RecoveryAccountForm = {
	identifier: string;
	code: string;
	password: string;
	confirmPassword: string;
};

type SendRecoveryAccountCodeForm = {
	identifier: string;
	senderType: MessageSenderTypeEnum;
};

type RegisteredUser = {
	fullName: string;
	email: string;
	phoneNumer: string;
	identifier: string;
};

type RecoveryInformation = {
	email: string;
	phone: string;
};

type AuthUserUpdate = {
	email: string;
	password: string;
	phoneNumber: string;
};

type UpdatePasswordUserAuthParams = {
	password: string;
	newPassword: string;
	confirmPassword: string;
};

export async function login(userIdentifier: string, password: string) {
	const { data } = await authApi.post<Token>("/auth/login", {
		identifier: onlyNumbers(userIdentifier),
		password: password,
	});
	return data;
}

export function logout() {
	localStorage.removeItem("tokens");
	localStorage.removeItem("uf");
	localStorage.removeItem("ibgeCode");
	localStorage.removeItem("cnes");
}

export async function refreshToken(accessToken: string, refreshToken: string) {
	const { data } = await authApi.post<Token>(`/auth/refresh`, {
		accessToken,
		refreshToken,
	});
	return data;
}

export async function validateAccount(identifier: string, validationCode: string) {
	const { data } = await authApi.get("/auth/validateAccount", {
		identifier: onlyNumbers(identifier),
		code: validationCode,
	});
	return Boolean(data);
}

export async function register(user: UserForm) {
	const response = await authApi.post<RegisteredUser>("/auth/register", {
		fullName: capitalize(user.name),
		email: user.email,
		identifier: onlyNumbers(user.identifier),
		phoneNumber: onlyNumbers(user.phone),
		password: user.password,
		confirmPassword: user.confirmPassword,
	});
	return response.status === 200;
}

export async function SendRecoveryAccountCode(params: SendRecoveryAccountCodeForm) {
	const response = await authApi.get("/auth/SendRecoveryAccountCode", {
		...params,
		identifier: onlyNumbers(params.identifier),
	});
	return response;
}

export async function recoveryAccount(params: RecoveryAccountForm) {
	const response = await authApi.post("/auth/RecoveryAccount", {
		...params,
		identifier: onlyNumbers(params.identifier),
	});
	return response.status === 200;
}

export async function recoveryInformation(identifier: string) {
	const { data } = await authApi.get<RecoveryInformation>("/auth/RecoveryInformation", {
		identifier: onlyNumbers(identifier),
	});
	return data;
}

export async function checkUserExists(identifier?: string, email?: string) {
	const { data } = await authApi.get<boolean>("/auth/CheckUserExists", {
		identifier: onlyNumbers(identifier || ""),
		email: email,
	});
	return data;
}

export async function updateUserAuth(user: User, password: string) {
	const { data } = await authApi.post<AuthUserUpdate>("/auth/Update", {
		password: password,
		email: user.email,
		phoneNumber: user.phone,
	});
	return data;
}

export async function updatePasswordUserAuth(params: UpdatePasswordUserAuthParams) {
	const response = await authApi.post("/auth/UpdatePassword", params);
	return response.status === 200;
}
